import { EditIcon, TableIconProps } from '@sim-admin-frontends/ui-shared';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { App } from '@sim-admin-frontends/data-access';

import ROUTES from '../../routing/routes';

type Props = {
  id: string;
  isEditPage?: boolean;
  app?: App;
};

export const useGeneratePaymentActions = ({ id, isEditPage, app }: Props) => {
  const { t } = useTranslation();
  const editPath = generatePath(ROUTES.paymentsEdit.path, { id, app });

  const generateItems = (): TableIconProps[] => [
    {
      label: t('table.dropdown.edit'),
      path: editPath,
      hidden: isEditPage,
      testId: 'PaymentsTableMenu#edit',
      icon: <EditIcon />,
    },
  ];

  const listItems = generateItems();
  const detailItems = generateItems().filter((i) => !i.hidden);

  return {
    listActions: listItems,
    detailActions: detailItems,
  };
};
